export const buildRagFlowModelLabel = (model) => {
  if (!model) return '';
  return model.nombre || model.Nombre || model.id || model.Id || model.llmId || model.LlmId || '';
};

export const normalizeRagFlowModelReference = (value) => String(value || '').trim();

export const parseRagFlowModelReference = (value) => {
  const normalized = normalizeRagFlowModelReference(value);
  if (!normalized) {
    return { model: '', instance: '', provider: '' };
  }

  const parts = normalized.split('@').map((part) => part.trim()).filter(Boolean);
  return {
    model: parts[0] || normalized,
    instance: parts[1] || '',
    provider: parts[2] || ''
  };
};

export const findSupportedAveChatModel = (models, value) => {
  const normalized = normalizeRagFlowModelReference(value);
  if (!normalized) return null;

  const modelList = Array.isArray(models) ? models : [];
  const parsed = parseRagFlowModelReference(normalized);
  return modelList.find((model) => {
    const modelName = parseRagFlowModelReference(model.id).model;
    const modelLabel = String(model.nombre || model.Nombre || '').trim();
    return normalized.toLowerCase() === model.id.toLowerCase() ||
      normalized.toLowerCase() === modelLabel.toLowerCase() ||
      normalized.toLowerCase() === modelName.toLowerCase() ||
      parsed.model.toLowerCase() === modelName.toLowerCase() ||
      parsed.model.toLowerCase() === modelLabel.toLowerCase();
  }) || null;
};

export const buildAveChatModelOptions = (models, assistantModel) => {
  const modelList = Array.isArray(models) ? models.filter((model) => model.id && model.nombre) : [];
  const selectedModel = findSupportedAveChatModel(modelList, assistantModel);
  if (selectedModel || !assistantModel || modelList.length > 0) {
    return modelList;
  }

  const normalized = normalizeRagFlowModelReference(assistantModel);
  return [
    {
      id: normalized,
      nombre: normalized,
      proveedor: '',
      instancia: '',
      tipo: 'chat',
      descripcion: 'Modelo guardado actualmente en el asistente. No se pudieron cargar detalles adicionales desde el catálogo de modelos.',
      caracteristicas: ['Modelo guardado actualmente en el asistente.']
    },
    ...modelList
  ];
};

export const getAveChatDefaultModelId = (models, assistantModel) => {
  const modelList = Array.isArray(models) ? models.filter((model) => model.id) : [];
  return findSupportedAveChatModel(modelList, assistantModel)?.id ||
    modelList[0]?.id ||
    normalizeRagFlowModelReference(assistantModel);
};

export const normalizeRagFlowModelsResponse = (response) => {
  const rawModels = response?.modelos || response?.Modelos || response?.models || response?.Models || response?.data || response?.Data || [];
  if (!Array.isArray(rawModels)) {
    return [];
  }

  return rawModels
    .map((model) => ({
      id: model.id || model.Id || model.llmId || model.LlmId || model.nombre || model.Nombre,
      nombre: model.nombre || model.Nombre || model.name || model.Name || model.id || model.Id || model.llmId || model.LlmId,
      proveedor: model.proveedor || model.Proveedor || model.provider || model.Provider || model.providerName || model.ProviderName || '',
      instancia: model.instancia || model.Instancia || model.instance || model.Instance || model.instanceName || model.InstanceName || '',
      tipo: model.tipo || model.Tipo || model.type || model.Type || '',
      maxTokens: model.maxTokens || model.MaxTokens || model.max_tokens || null,
      topN: model.topN || model.TopN || model.top_n || null,
      status: model.status || model.Status || model.estado || model.Estado || '',
      descripcion: model.descripcion || model.Descripcion || model.description || model.Description || '',
      esDefault: Boolean(model.esDefault || model.EsDefault || model.isDefault || model.IsDefault),
      caracteristicas: Array.isArray(model.caracteristicas)
        ? model.caracteristicas
        : Array.isArray(model.Caracteristicas)
          ? model.Caracteristicas
        : []
    }))
    .filter((model) => model.id && model.nombre);
};

export const getDefaultRagFlowModelId = (models) => {
  if (!Array.isArray(models) || models.length === 0) {
    return '';
  }

  return (models.find((model) => model.esDefault) || models[0]).id;
};
